
import { defineComponent, PropType } from "vue";
export default defineComponent({
  name: "skills-table-header",
});
